import { isMobile, isTablet } from '@resn/gozer-env';

const device = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
export { device };
